const UPDATE_MANIFEST = `mutation skipTask($input: [BatchUpdateAssignmentManifestInput!]!){
  batchUpdateAssignmentManifest(input: $input){
    manifest{
      activityType
      locale
      status
    }
  }
}
`;

const UPDATE_MANIFEST_ITEMS = `mutation UpdateManifestItemsMutation($updateManifestInput: [UpdateManifestItemInput]!, $timezone: String) {
  updateManifestItems(input: $updateManifestInput, timezone: $timezone) {
    success {
      assignmentId
      assignmentName
      assignmentType
      manifest {
        activityType
        manifestId
        status
        storyId
      }
    }
    reject {
      item {
        activityType
        assignmentId
        manifestId
        storyId
      }
      reason
    }
  }
}
`;

export default UPDATE_MANIFEST;
export { UPDATE_MANIFEST_ITEMS };
